
import { useCallback, useEffect, useState } from "react";
import CustomModal from "../../core/common/customModal";
import useFetch from "../../hooks/useFetch";
import { API } from "../../common/Constants";
import { getAPIHeaders } from "../../common/Utils";
import PreLoader from "./preLoader";
import CustomToast from '../../core/common/customToast';


interface Props {
  show: boolean;
  onDecline: () => void;
  onAccept?: () => void;
}

const TermsAndConditions = ({ show, onDecline, onAccept }: Props) => {
  const { isLoading, callFetch } = useFetch();
  const [termsDetails, setTermsDetails] = useState<any>(null);
  const [termsData, setTermsData] = useState<any>(null);
  const [toastSettings, setToastSettings] = useState<{
        show: boolean;
        message: string;
        heading: string;
        type: "ERROR" | "SUCCESS" | "INFO";
    }>({
        show: false,
        message: "Something went wrong please try again later",
        heading: "Oops! Something went wrong",
        type: "ERROR",
    });


  useEffect(() => {
    fetchTermsAndConditions();
  }, []);

  const fetchTermsAndConditions = () => {
    callFetch(API.TERMS_AND_CONDITIONS, "GET", getAPIHeaders(), null, null)
        .then((data) => {
          setTermsDetails(data);
          setTermsData(JSON.parse(data?.content));
        })
        .catch((error) => {
          console.error("Error fetching terms data:", error);
        });
  };

  const registerConsent = () => {
        const consentData = {
            documentId: termsDetails?.id,
        }

        callFetch(API.REGISTER_CONSENT, "POST", getAPIHeaders(), null, consentData).then(() => {
            if (onAccept) {
                onAccept();
            }
        }).catch(err => {
                setToastSettings({
                    show: true,
                    message: err?.response?.data || "Failed to register consent",
                    heading: "Error",
                    type: "ERROR",
                });
        });
    }
  const renderContent = (contentItems: any) => {
    if (!contentItems) return null;

    return contentItems.map((item: any, index: any) => {
      switch (item.type) {
        case "paragraph":
          return (
            <div key={index} >
              <p className="mt-1" dangerouslySetInnerHTML={{ __html: item.text || '' }}></p>
              {item.content && renderContent(item.content)}
            </div>
          );
        case "h2":
          return (
            <div key={index} >
              <h2 className="mt-2 mb-2" dangerouslySetInnerHTML={{ __html: item.text || '' }}></h2>
              {item.content && renderContent(item.content)}
            </div>
          );
        case "ul":
          return (
            <ul key={index} >
              {item.items.map((listItem: any, listIndex: any) => (
                <li key={listIndex} >
                  {listItem.text && (
                    <label >
                      <span className="text-dark me-2">•</span>
                      <span dangerouslySetInnerHTML={{ __html: listItem.text || '' }}></span>
                    </label>
                  )}
                  {listItem.content && (
                    <div className="ms-4">
                      {renderContent(listItem.content)}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          );
        case "li":
          return (
            <li key={index} >
              {item.text && (
                <label >
                  <span className="text-dark me-2">•</span>
                  <span dangerouslySetInnerHTML={{ __html: item.text || '' }}></span>
                </label>
              )}
              {item.content && (
                <div className="ms-4">
                  {renderContent(item.content)}
                </div>
              )}
            </li>
          );
        default:
          return null;
      }
    });
  };
  return (
    <div>
      <style>{`
        .terms-conditions-content a {
          color: #007bff;
          text-decoration: underline;
        }
        .terms-conditions-content a:hover {
          color: #0056b3;
        }
      `}</style>
      <PreLoader showLoader={isLoading} />
      <CustomToast
        show={toastSettings?.show}
        message={toastSettings?.message}
        heading={toastSettings?.heading}
        type={toastSettings?.type}
        onClose={() => {
            setToastSettings((prev) => ({
                ...prev,
                show: false,
            }));
        }}
      />
      <CustomModal
        backdrop="static"
        size="xl"
        show={show}
        onClose={onDecline}
        title={"Terms and Conditions"}
        bodyContent={
          <div className="overflow-auto terms-conditions-content" style={{ maxHeight: '60vh' }}>
            <>{renderContent(termsData?.content)}</>
          </div>        
        }
        footerContent={
          <div className={"w-100 flex-column d-flex"}>
            <div className="align-self-end">
             <button
                className="btn btn-success me-2"
                onClick={registerConsent}
              >
                Accept
              </button>
              <button
                className="btn btn-danger me-2"
                onClick={onDecline}
              >
                Decline
              </button>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default TermsAndConditions;